<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <div class="copyright d-flex flex-wrap">
        v. {{ $root.version }} &copy; 2020 Rob Wisehart -- of the Arizona Wiseharts
      </div>
    </div>
  </footer>
</template>
<script>
export default {}
</script>
